import {
	connect
} from 'react-redux'
import FittingOrderersComponent from '../components/FittingOrderersComponent.jsx';
import {
	closeFittingOrdererModal
} from '../actions';

const mapStateToProps = (state) => ({
	orderId: state.getIn(['fittingReducer', 'orderId']),
	showFittingOrdererModal: state.getIn(['fittingReducer', 'showFittingOrdererModal']),
})

const mapDispatchToProps = (dispatch) => ({
	closeModal: () => {
		dispatch(closeFittingOrdererModal());
	},
})

const FittingOrderersContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(FittingOrderersComponent)

export default FittingOrderersContainer;


// WEBPACK FOOTER //
// ./src/containers/FittingOrderersContainer.jsx